import React from 'react';

export const IntroSection = (props) => {
  const { title, subtitle } = props;
  return (
    <section className="intro-section">
      <div className="wrapper">
        <h1>{title}</h1>
        <h2 dangerouslySetInnerHTML={{__html: subtitle}} />
      </div>
    </section>
  )
}
